import Constants from '../actions/types';
import { removeMilliseconds } from 'src/utils';

const initialState = {
  customMetrics: [],
  loading: false,
  message: null,
  severity: null
};

const customMetricsReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.CUSTOMMETRICS_GET_REQUEST: {
      const newState = {
        ...state,
        loading: true,
        message: null,
        severity: null
      };

      return newState;
    }

    case Constants.CUSTOMMETRICS_GET_SUCCESS: {
      const data = action.payload.map(value => removeMilliseconds(value));
      const newState = {
        ...state,
        customMetrics: data,
        loading: false
      };

      return newState;
    }

    case Constants.CUSTOMMETRICS_GET_FAILURE: {
      const newState = {
        ...state,
        customMetrics: [],
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.CUSTOMMETRICS_LABEL_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.CUSTOMMETRICS_SAVE_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.CUSTOMMETRICS_SAVE_REQUEST: {
      const newState = {
        ...state,
        loading: true
      };

      return newState;
    }

    case Constants.CUSTOMMETRICS_SAVE_SUCCESS: {
      const newState = {
        ...state,
        loading: false
      };

      return newState;
    }

    case Constants.CUSTOMMETRICS_LABEL_SUCCESS: {
      const newState = {
        ...state,
        customMetrics: state.customMetrics.map(item => {
          if (item.id === action.payload.id) {
            return action.payload;
          }
          return item;
        })
      };

      return newState;
    }

    case Constants.CUSTOMMETRICS_CLEAR_ERROR: {
      const newState = {
        ...state,
        message: null,
        severity: null
      };

      return newState;
    }

    default: {
      return state;
    }
  }
};

export default customMetricsReducer;
